
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/cancel-return-exchange/processed",
      function () {
        return require("private-next-pages/mypage/cancel-return-exchange/processed.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/cancel-return-exchange/processed"])
      });
    }
  